import { siteServiceOptions as DEFAULT_SERVICE_OPTIONS } from "./themeColors";

const normalizeServiceOptions = (raw) => {
	if (!raw) return null;
	const parsed = Array.isArray(raw)
		? raw
		: (() => {
			if (typeof raw !== "string") return null;
			try {
				return JSON.parse(raw);
			} catch {
				return null;
			}
		})();

	if (!Array.isArray(parsed)) return null;

	const sanitized = parsed
		.map((item) => ({
			key: String(item?.key || "").trim(),
			label: String(item?.label || "").trim(),
			description: String(item?.description || "").trim(),
			href: String(item?.href || "").trim(),
		}))
		.filter((item) => item.key && item.label);

	return sanitized.length > 0 ? sanitized : null;
};

export const resolveServiceOptions = (optionKeys) => {
	const fromOptions = normalizeServiceOptions(optionKeys?.customerLocationServices);
	if (fromOptions) return fromOptions;
	return Array.isArray(DEFAULT_SERVICE_OPTIONS) ? DEFAULT_SERVICE_OPTIONS : [];
};

export const serializeServiceOptions = (services = []) => {
	const sanitized = (Array.isArray(services) ? services : [])
		.map((item) => ({
			key: String(item?.key || "").trim(),
			label: String(item?.label || "").trim(),
			description: String(item?.description || "").trim(),
			href: String(item?.href || "").trim(),
		}))
		.filter((item) => item.key && item.label);
	return JSON.stringify(sanitized);
};

export const getCustomerLocationOptionFlags = (optionKeys) => ({
	servicesEnabled: optionKeys?.customerLocationServicesEnabled !== "false",
	showLegalEntity: optionKeys?.customerLocationShowLegalEntity !== "false",
	showSite: optionKeys?.customerLocationShowSite !== "false",
	showWarehouse: optionKeys?.customerLocationShowWarehouse !== "false",
	showPaymentTerms: optionKeys?.customerLocationShowPaymentTerms !== "false",
	showOnHold: optionKeys?.customerLocationShowOnHold !== "false",
});

